import angular from 'angular';
import retailerReportsRoutingModule from './retailer-reports-routing-module';
import retailerReportsPageModule from './components/retailer-reports-page/retailer-reports-page-module';
import retailerReportsFilterModule from './components/retailer-reports-filter/retailer-reports-filter-module';
import retailerReportsTabContentModule from './components/retailer-reports-tab-content/retailer-reports-tab-content-module';

export default angular.module('retailer-reports', [
  retailerReportsRoutingModule.name,
  retailerReportsPageModule.name,
  retailerReportsFilterModule.name,
  retailerReportsTabContentModule.name,
]);



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/retailer-reports-module.js